import i18nFactory from '@yandex-int/i18n';
import { routerForBrowser } from 'redux-little-router';

import * as keyset from './index.i18n';

const i18n = i18nFactory(keyset);

export enum RoutesPath {
    log = '/dna/log',
    grid = '/dna/grid/:view',
    shortGrid = '/dna/grid',
    welcome = '/dna/welcome',
    freelancerCard = '/dna/freelancers/:freelancerLogin',
    freelancerCustomers = '/dna/customers',
    freelancersEdit = '/dna/freelancers/:freelancerLogin/edit',
    freelancersList = '/dna/freelancers',
    offlineReports = '/dna/offline-reports',
    domainsReports = '/dna/domains-reports',
    recommendationsPage = '/dna/recommendations',
    recommendationsItems = '/dna/recommendations-grid/:type',
    shortMobileApps = '/dna/mobile-apps/',
    mobileAppsList = '/dna/mobile-apps/list',
    mobileAppsEdit = '/dna/mobile-apps/edit/:mobileAppId',
    mobileAppsCreate = '/dna/mobile-apps/create',
    deals = '/dna/deals',
    bannersEdit = '/dna/banners-edit',
    internalBannersEdit = '/dna/internal-banners-edit',
    tools = '/dna/tools',
    notFound = '/*',
    groupsEdit = '/dna/groups-edit',
    minusPhrasesLibrary = '/dna/library/minusPhrase',
    campaignsEdit = '/dna/campaigns-edit',
    products = '/dna/products',
    marketers = '/dna/marketers',
    marketerCard = '/dna/marketers/:id'
}

export const PUBLIC_DOMAIN_PAGES = [
    RoutesPath.freelancerCard,
    RoutesPath.freelancersList
];

export const recommendationTypeParam = {
    dailyBudget: 'dailyBudget',
    switchOnAutotargeting: 'switchOnAutotargeting',
    removePagesFromBlackList: 'removePagesFromBlackList'
};

const routes: Record<RoutesPath, { title?: string }> = {
    [RoutesPath.log]: {
        title: i18n('clientHistory')
    },
    [RoutesPath.grid]: {},
    [RoutesPath.shortGrid]: {},
    [RoutesPath.shortMobileApps]: {},
    [RoutesPath.mobileAppsList]: {
        title: i18n('mobileAppsList')
    },
    [RoutesPath.mobileAppsEdit]: {
        title: i18n('mobileAppsEdit')
    },
    [RoutesPath.mobileAppsCreate]: {
        title: i18n('mobileAppsCreate')
    },
    [RoutesPath.welcome]: {
        title: i18n('welcome')
    },
    [RoutesPath.deals]: {
        title: i18n('deals')
    },
    [RoutesPath.freelancersEdit]: {
        title: i18n('freelancerCardEdit')
    },
    [RoutesPath.freelancersList]: {
        title: i18n('freelancersList')
    },
    [RoutesPath.freelancerCard]: {
        title: i18n('freelancerCard')
    },
    [RoutesPath.freelancerCustomers]: {
        title: i18n('freelancerCustomers')
    },
    [RoutesPath.offlineReports]: {
        title: i18n('clientsReports')
    },
    [RoutesPath.domainsReports]: {
        title: i18n('domainsReports')
    },
    [RoutesPath.recommendationsPage]: {
        title: i18n('recommendationsPage')
    },
    [RoutesPath.recommendationsItems]: {
        title: i18n('recommendationsItems')
    },
    [RoutesPath.internalBannersEdit]: {
        title: i18n('bannersEdit')
    },
    [RoutesPath.bannersEdit]: {
        title: i18n('bannersEdit')
    },
    [RoutesPath.groupsEdit]: {
        title: i18n('groupsEdit')
    },
    [RoutesPath.tools]: {
        title: i18n('tools')
    },
    [RoutesPath.minusPhrasesLibrary]: {
        title: i18n('minusPhrasesLibrary')
    },
    [RoutesPath.campaignsEdit]: {
        title: i18n('campaignsEdit')
    },
    [RoutesPath.products]: {
        title: i18n('products')
    },
    [RoutesPath.marketers]: {
        title: i18n('marketers')
    },
    [RoutesPath.marketerCard]: {
        title: i18n('marketerCard')
    },
    [RoutesPath.notFound]: {}
};

export const { reducer, enhancer, middleware } = routerForBrowser({ routes });
